import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThunderstormComponent } from './thunderstorm.component';
import { SharedModule } from '../../shared/shared.module';
import { DataService } from '../thunderstorm/utils/service/data.service';
import { MapService } from '../thunderstorm/utils/service/map.service';
import { ThunderstormService } from './utils/service/thunderstorm.service';



@NgModule({
  declarations: [ThunderstormComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [ThunderstormComponent],
  providers: [DataService, MapService, ThunderstormService]
})
export class ThunderstormModule { }
